module.exports = __webpack_public_path__ + "img/round-red.f4affa38.svg";